import { render, staticRenderFns } from "./railway-control.vue?vue&type=template&id=038d5a40"
import script from "./railway-control.vue?vue&type=script&lang=js"
export * from "./railway-control.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports